import { Tile, Header } from 'shared/components/Tile';

import { Action } from './components/Action';
import { Content } from './components/Content';
import { Title } from './components/Title';

import type { CumulativeGradesProps } from './types';
import type { FC } from 'react';

export const CumulativeGrades: FC<CumulativeGradesProps> = ({
  data,
  isLoading = false,
  gridArea,
  onInteract,
}) => {
  const gradeType = data?.gradeType || 'Cumulative';

  return (
    <Tile sx={{ gridArea, minHeight: 362 }}>
      <Header>
        <Title isLoading={isLoading} gradeType={gradeType} />
        <Action isLoading={isLoading} gradeType={gradeType} />
      </Header>
      <Content
        isLoading={isLoading}
        data={data}
        onInteract={onInteract}
        gradeType={gradeType}
      />
    </Tile>
  );
};
